/** Chatur's WhatsApp number, without the '+'. Unset in environments that haven't been given one. */
export const CHATUR_WA_NUMBER = import.meta.env.VITE_CHATUR_WA_NUMBER as string | undefined;

/** Opens the Chatur chat on WhatsApp. Returns false when no number is configured. */
export const openChaturChat = (): boolean => {
  if (!CHATUR_WA_NUMBER) return false;
  window.open(`https://wa.me/${CHATUR_WA_NUMBER}`, "_blank", "noopener,noreferrer");
  return true;
};
